import { theme as commonTheme, AlyceTheme, AlycePalette } from '@alycecom/ui';
import { createTheme } from '@mui/material';

import { defaultBrandingColors } from '../constants/branding.constants';

export interface ICustomPalette {
  backgroundColor: string;
  primaryColor: string;
  secondaryColor: string;
  tertiaryColor: string;
  highlightColor: string;
  headlineColor: string;
  primaryCtaColor: string;
  secondaryCtaColor: string;
}

export interface IAlyceCustomTheme extends AlyceTheme {
  palette: AlycePalette & {
    customStyling: ICustomPalette;
  };
}

const values = {
  xs: 0,
  sm: 600,
  lg: 960,
};

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: false; // removing the `md` breakpoint
    lg: true;
    xl: false;
  }
}
export const theme = createTheme({
  ...commonTheme,
  breakpoints: {
    keys: ['xs', 'sm', 'lg'],
    up: key => `@media (min-width:${typeof key === 'number' ? key : values[key]}px)`,
  },
  palette: {
    ...commonTheme.palette,
    // todo figure out ts
    // @ts-ignore
    customStyling: {
      ...defaultBrandingColors,
    },
  },
  components: {
    ...commonTheme.components,

    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontWeight: 'normal',
          color: commonTheme.palette.text.primary,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          marginTop: 4,
          marginLeft: 0,
          marginRight: 14,
        },
      },
    },
  },
});
